import Vue from 'vue';
import {
  NavBar,
  Button,
  Row,
  Col,
  Icon,
  Toast,
  Dialog,
  Cell,
  CellGroup,
  Popup,
  Loading,
  Stepper,
  Field,
  SwitchCell,
  Switch,
  Search,
  PullRefresh,
  NoticeBar,
  Collapse,
  CollapseItem,
  SwipeCell,
  DatetimePicker,
  Picker,
  PasswordInput,
  NumberKeyboard,
} from 'vant';

import 'vant/lib/vant-css/base.css';
import 'vant/lib/vant-css/nav-bar.css';
import 'vant/lib/vant-css/button.css';
import 'vant/lib/vant-css/row.css';
import 'vant/lib/vant-css/col.css';
// import 'vant/lib/vant-css/icon.css';
import 'vant/lib/vant-css/toast.css';
import 'vant/lib/vant-css/dialog.css';
import 'vant/lib/vant-css/cell.css';
import 'vant/lib/vant-css/popup.css';
import 'vant/lib/vant-css/loading.css';
import 'vant/lib/vant-css/stepper.css';
import 'vant/lib/vant-css/field.css';
import 'vant/lib/vant-css/switch-cell.css';
import 'vant/lib/vant-css/switch.css';
import 'vant/lib/vant-css/search.css';
import 'vant/lib/vant-css/pull-refresh.css';
import 'vant/lib/vant-css/notice-bar.css';
import 'vant/lib/vant-css/collapse.css';
import 'vant/lib/vant-css/swipe-cell.css';
import 'vant/lib/vant-css/picker.css';
import 'vant/lib/vant-css/password-input.css';
import 'vant/lib/vant-css/number-keyboard.css';

Vue.use(NavBar);
Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(Stepper);
Vue.use(Field);
Vue.use(SwitchCell);
Vue.use(Switch);
Vue.use(Search);
Vue.use(PullRefresh);
Vue.use(NoticeBar);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(SwipeCell);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
